import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateUserChangeTransaction = {
  userChangeTransaction: { data: null, loading: false, error: null },
};

export const userChangeTransaction = createAsyncThunk('user/userChangeTransaction', async ({ transactionId, status }, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .post(`/transaction/${transactionId}/change-status`, { status })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerUserChangeTransaction = {
  [userChangeTransaction.pending]: (state) => {
    state.userChangeTransaction.loading = true;
  },
  [userChangeTransaction.fulfilled]: (state, action) => {
    state.userChangeTransaction.loading = false;
    state.userChangeTransaction.data = action.payload;
    state.userChangeTransaction.error = null;
  },
  [userChangeTransaction.rejected]: (state, action) => {
    state.userChangeTransaction.loading = false;
    state.userChangeTransaction.error = action.payload;
  },
};
